import { some, chain, get, times, sum, slice, each } from "lodash"

export function recursiveStickyCheck(columns) {
  return some(columns, column => {
    if (column.columns) {
      return recursiveStickyCheck(column.columns)
    }
    return column.isSticky
  })
}

export function handleResizeObserver(tableRef, numberOfStickyColumns) {
  const parentNodes = get(tableRef, "current.childNodes")
  if (!parentNodes) { return }
  // We need to find out the left positions of the first 3 columns
  // 1st: 0
  // 2+: 0 + sum(previous widths)
  // First we get the nodes of the first row with non grouped columns and get their widths
  const widths = chain(parentNodes)
    .get(0) // parentNodes contains thead and tbody, we only want thead
    .get("childNodes")
    .get(1) // TableHead contains 3 rows: Group Labels, Labels, Total and we want the Labels row
    .get("childNodes")
    .take(numberOfStickyColumns)
  // We're using getBoundingClientRect() instead of offsetWith because it gives you fractionated width values
    .map(node => node?.getBoundingClientRect().width)
    .value()
  const positions = [
    0,
    ...times(numberOfStickyColumns, (index) => sum(slice(widths, 0, index + 1))),
  ]

  each(parentNodes, parentNode => {
    const nodes = parentNode.childNodes
    each(nodes, (node) => {
      // Only iterate through columns that are sticky
      const children = node.getElementsByClassName("sticky-left")
      for (let index = 0; index < children.length; index++) {
        children[index].style.left = `${positions[index]}px`
        children[index].classList.add(`sticky-left-${index + 1}`)
        if (index === children.length - 1) {
          children[index].classList.add("sticky-left-last")
        }
      }
    })
  })
}
